<template lang="pug">
.datepicker
  label {{ label }}
    span(v-if='required') *

  v-text-field(
    v-bind='$attrs',
    v-model='dateFormatted',
    placeholder='DD-MM-YYYY',
    prepend-inner-icon='fa fa-calendar',
    @click:prepend-inner='dateMenuOpen = true',
    solo,
    :error-messages='dateFormattedValidationErrors',
    @change='$v.dateFormatted.$touch()',
    @blur='$v.dateFormatted.$touch()',
    mask='##-##-####'
    )

  v-dialog(ref='birthdateDialog', v-model='dateMenuOpen', lazy, full-width, width='290px')
    v-date-picker(
      ref='datePicker',
      v-model='date',
      :max='new Date().toISOString().substr(0, 10)',
      min='1900-01-01',
      @change='dateSave',
      locale='nl',
      @blur='date = parseDate(dateFormatted)'
      )

</template>

<script>
import { parseDateString, toIsoDateString } from './helpers/date'
// import { requiredIf } from 'vuelidate/lib/validators'
import requiredIf from 'vuelidate/src/validators/requiredIf'
import { format, isBefore, subYears } from 'date-fns'

export default {
  props: {
    value: null,
    'error-messages': null,
    label: String,
    propName: String,
    required: Boolean,
    minimumAge: Boolean
  },

  data () {
    return {
      date: this.value,

      datePickerOpen: false,
      dateFormatted: null,
      dateMenuOpen: false
    }
  },

  computed: {
    dateFormattedValidationErrors () {
      const errors = []
      if (!this.$v.dateFormatted.$dirty) return errors
      this.$v.dateFormatted.required === false && errors.push('Dit veld is verplicht')
      this.$v.dateFormatted.minimumAge === false && errors.push('U moet minimaal 18 jaar zijn om een lease aan te vragen')
      !this.$v.dateFormatted.date && errors.push('Datum moet in het volgende formaat zijn: 25-12-1995')
      return errors
    }
  },

  methods: {
    onBlur () {
      if (this.$listeners.blur) this.$listeners.blur()
    },

    onChange () {
      if (this.$listeners.change) this.$listeners.change()
    },

    formatDate (date) {
      if (!date) return null

      return format(date, 'ddMMyyyy')
    },

    parseDate (dateString) {
      if (!dateString) return null

      if (!/^\d{8}$/.test(dateString)) return

      return toIsoDateString(parseDateString(dateString))
    },

    dateSave (date) {
      this.date = date
      this.dateFormatted = this.formatDate(date)
      this.dateMenuOpen = false
    }
  },

  validations: {
    dateFormatted: {
      required: requiredIf(vm => vm.required),
      date: (v) => /^\d{8}$/.test(v),
      minimumAge: function (v, vm) {
        if (vm.minimumAge) {
          return isBefore(parseDateString(v), subYears(new Date(), 18))
        }

        return true
      }
    }
  },

  watch: {
    date (v) {
      this.$emit('input', v)

      this.dateFormatted = this.formatDate(this.date) // Doesnt this cause an infinite loop?
    },

    value (v) {
      this.date = v
    },

    dateMenuOpen (v) {
      v && this.$nextTick(() => (this.$refs.datePicker.activePicker = 'YEAR'))
    },

    dateFormatted (v) {
      this.date = this.parseDate(v)
    },

    '$v.$invalid': {
      handler: function (invalid) {
        this.$emit('setValid', {
          propName: this.propName,
          valid: !invalid
        })
      },
      deep: true,
      immediate: true
    }
  },

  created () {
    if (this.date) {
      this.dateFormatted = this.formatDate(this.date)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
